import {Checkbox, FormControlLabel, Radio, Stack, Typography} from "@mui/material";
import {Check, Close} from "@mui/icons-material";
import { DropdownAnswerSubtypeResponse, DropdownAnswerSubtypeDataModel, DropdownAnswerItem, DropdownItemAnswers } from "../../../../../../types/actionModule/subtypes/dropdownAnswerSubtype";

interface Props {
    subtype: DropdownAnswerSubtypeResponse;
    subtypeData: DropdownAnswerSubtypeDataModel;
}

export default function DropdownAnswerSubtypeDetails(props: Props) {
    return (
        <Stack direction="column">
            {
                props.subtype.checklistItems.map(c => <DropdownAnswerItemComponent
                        key={c.id}
                        subtype={props.subtype}
                        item={c}
                        answer={props.subtypeData.answers[c.id]}
                    />
                )
            }
        </Stack>
    );
}


interface DropdownAnswerItemProps {
    subtype: DropdownAnswerSubtypeResponse;
    item: DropdownAnswerItem;
    answer: DropdownItemAnswers;
}

function DropdownAnswerItemComponent(props: DropdownAnswerItemProps) {
    switch (props.subtype.checklistAnswerType) {
        case "SingleChoice":
            return <FormControlLabel
                label={props.item.text}
                control={
                    <Radio
                        checked={props.answer === "CheckedPositive"}
                        onChange={() => { }}
                    />
                }
            />;
        case "MultipleChoice":
            return <FormControlLabel
                label={props.item.text}
                control={
                    <Checkbox
                        checked={props.answer === "CheckedPositive"}
                        onChange={() => { }}
                    />
                }
            />;
        case "MultipleChoiceWithDecline":
            if (props.answer === "NotChecked") {
                return <></>
            }

            return <Stack direction={"row"}>
                {props.answer === "CheckedPositive" && <Check sx={{ color: "green" }} />}
                {props.answer === "CheckedNegative" && <Close sx={{ color: "red" }} />}
                <Typography>{props.item.text}</Typography>
            </Stack>;
    }
}